import { useState, useEffect } from 'react'

// Generic media query hook
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)

    function handleChange(e: MediaQueryListEvent) {
      setMatches(e.matches)
    }

    // Set initial value
    setMatches(mediaQuery.matches)

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [query])

  return matches
}

// Convenience hook for mobile detection (768px breakpoint)
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 768px)')
}

// Convenience hook for tablet detection
export function useIsTablet(): boolean {
  return useMediaQuery('(min-width: 769px) and (max-width: 1024px)')
}

// Convenience hook for desktop detection
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1025px)')
}
